import { buildReducer } from '../../../shared';
import type PdlEmailsPickerState from '../../state/pdlEmailsPickerState';
import {
    addSomePersonasToPDLClickedAction,
    addSomePersonasAndCreatePDLClickedAction,
    pdlEmailsPickerConfirmClicked,
    dismissPdlEmailsPickerDialog,
} from '../../actions/user/contactListsActions';

import {
    privateDLAddMembersCompletedAction,
    privateDLCreateCompletedAction,
} from '../../../privatedlcreateedit';

export type { PdlEmailsPickerState };

const defaultState: PdlEmailsPickerState = {
    actionType: 'Add',
    showDialog: false,
    isError: false,
    isInProgress: false,
    currentList: null,
    listName: '',
    defaultFolderId: '',
    personas: [],
};

export default buildReducer<PdlEmailsPickerState>()
    .handle(addSomePersonasToPDLClickedAction, (state, action) => ({
        ...state,
        currentList: action.payload.currentList,
        personas: action.payload.personas,
        showDialog: true,
    }))
    .handle(addSomePersonasAndCreatePDLClickedAction, (state, action) => ({
        ...state,
        actionType: 'Create',
        listName: action.payload.listName,
        personas: action.payload.personas,
        defaultFolderId: action.payload.defaultFolderId,
        showDialog: true,
    }))
    .handle(pdlEmailsPickerConfirmClicked, (state, action) => ({
        ...state,
        isInProgress: true,
    }))
    .handleDataAction(
        privateDLAddMembersCompletedAction,
        (state, action) => {
            if (
                state.currentList &&
                action.payload.hubPersonaId === state.currentList.hubPersonaId
            ) {
                return {
                    ...defaultState,
                };
            } else {
                return {
                    ...state,
                };
            }
        },
        (state, action) => {
            if (
                state.currentList &&
                action.payload.hubPersonaId === state.currentList.hubPersonaId
            ) {
                return {
                    ...state,
                    isError: true,
                };
            } else {
                return {
                    ...state,
                };
            }
        }
    )
    .handleDataAction(
        privateDLCreateCompletedAction,
        (state, action) => {
            if (
                !state.currentList &&
                action.payload.privateDL.info.listOriginalDisplayName === state.listName
            ) {
                return {
                    ...defaultState,
                };
            } else {
                return {
                    ...state,
                };
            }
        },
        (state, action) => {
            if (!state.currentList && action.payload.name === state.listName) {
                return {
                    ...state,
                    isError: true,
                };
            } else {
                return {
                    ...state,
                };
            }
        }
    )
    .handle(dismissPdlEmailsPickerDialog, state => ({
        ...defaultState,
    }))
    .done(defaultState);
export type { Action } from '../../../shared';
